import { render, staticRenderFns } from "./Pullout.vue?vue&type=template&id=87d1be28&functional=true&"
var script = {}
import style0 from "./Pullout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports